import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.oidc.authority,
    authWellknownEndpointUrl:
      environment.oidc.authority + '/.well-known/openid-configuration',
    redirectUrl:           environment.oidc.redirectUri,
    postLogoutRedirectUri: environment.oidc.postLogoutRedirectUri,

    clientId:       environment.oidc.clientId,
    responseType:   environment.oidc.responseType,
    scope:          environment.oidc.scope,

    silentRenew:     environment.oidc.silentRenew,
    useRefreshToken: environment.oidc.useRefreshToken,
    secureRoutes: [
      'http://localhost:5268',
      'https://cde-oxy.g-talent.cl/api',
    ],
  },
  
};
